import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import albumReducer from './slices/albumSlice';
import imageReducer from './slices/imageSlice';
import categoryReducer from './slices/categoriesSlice';
import planReducer from './slices/planSlice';
import contactReducer from './slices/contactSlice';

const appReducer = combineReducers({
  auth: authReducer,
  albums: albumReducer,
  images: imageReducer,
  categories: categoryReducer,
  plans: planReducer,
  contact: contactReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_APP') {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;